import { render, staticRenderFns } from "./Shoplist.vue?vue&type=template&id=15248508&"
import script from "./Shoplist.vue?vue&type=script&lang=js&"
export * from "./Shoplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports